export const environment = {
    production: false,
    identityUrl: 'https://identity-v2-staging.nside.io',
    withCredentials: true,
    angularAppUrl: 'https://tips-dash-v2-staging.nside.io',
    apiBaseUrl: 'https://tips-v2-staging.nside.io',
    assessApiBaseUrl: 'https://assess-api-staging.nside.io'
};
